import { PinDropOutlined } from "@mui/icons-material";
import {
  Box,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomCheckbox from "../../../components/ui/CustomCheckbox";
import MuiDatePicker from "../../../components/ui/DateAndTimePicker";
import { CAR_DELIVERY_OPTIONS } from "../../../utils/constants/carEstimate";
import AddressAutocomplete from "../../../components/custom/react-google-maps/AddressAutoComplete";
import React from "react";

export const DeliveryOptionsSection = ({ formik }) => {

  const { t } = useTranslation("carEstimateAuction");

  const isMobile = useMediaQuery("(max-width:1480px)");

  const handleDeliveryOptionChange = (option) => {
    formik.setFieldValue("deliveryOption", option);
    if (option === CAR_DELIVERY_OPTIONS.Dropoff) {
      formik.setFieldValue("address", "");
    }
  };

  const setAddress = (address) => {
    console.log(address, "setAddress");

    let zipCode = "",
      state = "",
      city = "",
      premise = "",
      subpremise = "",
      street_number = "",
      route = "",
      neighborhood = "",
      sublocality = "",
      line2 = "",
      line1 = "",
      latitude = null,
      longitude = null;

    // Extract latitude and longitude
    if (address?.geometry?.location) {
      if (typeof address.geometry.location.lat === 'function') {
        latitude = address.geometry.location.lat();
      } else {
        latitude = address.geometry.location.lat;
      }

      if (typeof address.geometry.location.lng === 'function') {
        longitude = address.geometry.location.lng();
      } else {
        longitude = address.geometry.location.lng;
      }
    }

    for (let i = 0; i < address?.address_components?.length; i++) {
      if (address?.address_components?.[i]?.types?.includes("premise")) {
        premise = address?.address_components?.[i]?.long_name;
      } else if (
        address?.address_components?.[i]?.types?.includes("subpremise")
      ) {
        subpremise = address?.address_components?.[i]?.long_name;
      } else if (
        address?.address_components?.[i]?.types?.includes("street_number")
      ) {
        street_number = address?.address_components?.[i]?.long_name;
      } else if (address?.address_components?.[i]?.types?.includes("route")) {
        route = address?.address_components?.[i]?.long_name;
      } else if (
        address?.address_components?.[i]?.types?.includes("neighborhood")
      ) {
        neighborhood = address?.address_components?.[i]?.long_name;
      } else if (
        address?.address_components?.[i]?.types?.includes?.("sublocality")
      ) {
        sublocality = address?.address_components?.[i]?.long_name;
      } else if (
        address?.address_components?.[i]?.types?.includes("postal_code")
      ) {
        zipCode = address?.address_components?.[i]?.long_name;
      } else if (
        address?.address_components?.[i]?.types?.includes(
          "administrative_area_level_1",
        )
      ) {
        state = address?.address_components?.[i]?.long_name;
      } else if (
        address?.address_components?.[i]?.types?.includes("locality")
      ) {
        city = address?.address_components?.[i]?.long_name;
      }
    }

    line1 = `${premise ? premise + ", " : ""}${subpremise ? subpremise + ", " : ""
      }${street_number ? street_number + ", " : ""}${route ? route : ""}`;
    line2 = `${neighborhood ? neighborhood + ", " : ""}${sublocality ? sublocality : ""
      }`;

    if (!city) {
      city = state;
    }

    const fullAddress = `${line1 ? `${line1} ` : ""}${city ? `${city} ` : ""}${state ? `${state} ` : ""}${zipCode ? `${zipCode} ` : ""}`
    formik?.setValues?.(values => {
      return {
        ...values,
        lat: latitude,
        long: longitude,
        address: fullAddress?.trim?.()
      }
    })
  };

//   return (
//     <Grid container spacing={2} width={"100%"}
//       sx={{
//         alignItems: "center"
//       }}
//     >
//       <Grid
//         item
//         size={{
//           xs: 12,
//           lg: isMobile ? 12 : 3,
//         }}
//       >
//         <Typography color="text.form" variant="h6" fontSize={"1rem"}>
//           Delivery Option
//         </Typography>
//         <Box display={"flex"} gap={2} mt={2}>
//           <CustomCheckbox
//             label={CAR_DELIVERY_OPTIONS.Pickup}
//             selected={
//               formik.values.deliveryOption === CAR_DELIVERY_OPTIONS.Pickup
//             }
//             onClick={() =>
//               handleDeliveryOptionChange(CAR_DELIVERY_OPTIONS.Pickup)
//             }
//           />
//           <CustomCheckbox
//             label={"Drop Off"}
//             selected={
//               formik.values.deliveryOption === CAR_DELIVERY_OPTIONS.Dropoff
//             }
//             onClick={() =>
//               handleDeliveryOptionChange(CAR_DELIVERY_OPTIONS.Dropoff)
//             }
//           />
//         </Box>
//       </Grid>
//       <Grid
//         item
//         size={{
//           xs: 12,
//           lg: isMobile ? 12 : 6,
//         }}
//       >
//         <Typography color="text.form" variant="h6" fontSize={"1rem"} mb={1}>
//           CarChaser's Address: 20-4544 Dufferin St, North York M3H 5X2
//         </Typography>
//         <AddressAutocomplete
//           setAddress={setAddress}
//         >
//           <TextField
//             name="address"
//             value={formik.values.address}
//             onChange={formik.handleChange}
//             onBlur={formik.handleBlur}
//             error={
//               formik.touched.address &&
//               Boolean(formik.errors.address) &&
//               formik.values.deliveryOption === CAR_DELIVERY_OPTIONS.Pickup
//             }
//             helperText={
//               formik.touched.address &&
//               formik.errors.address &&
//               formik.values.deliveryOption === CAR_DELIVERY_OPTIONS.Pickup
//             }
//             fullWidth
//             placeholder="20-4544 Dufferin St, North York M3H 5X2"
//             disabled={
//               formik.values.deliveryOption === CAR_DELIVERY_OPTIONS.Dropoff
//             }
//             sx={{
//               "& .MuiInputBase-root": {
//                 height: 42,
//               },
//               "& .MuiOutlinedInput-input": {
//                 padding: "10px 14px",
//               },
//             }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <PinDropOutlined />
//                 </InputAdornment>
//               ),
//             }}
//           />
//         </AddressAutocomplete>

//       </Grid>
//       <Grid
//         item
//         size={{
//           xs: 12,
//           lg: isMobile ? 12 : 3,
//         }}
//       >
//         <Typography color="text.form" variant="h6" fontSize={"1rem"} mb>
//           Pickup or Drop Off Date
//         </Typography>
//         <MuiDatePicker
//           label="MM-DD-YYYY"
//           disablePast
//           value={formik.values.pickupDate}
//           onChange={(value) => formik.setFieldValue("pickupDate", value)}
//           error={formik.touched.pickupDate && Boolean(formik.errors.pickupDate)}
//           helperText={formik.touched.pickupDate && formik.errors.pickupDate}
//         />
//       </Grid>
//     </Grid>
//   );
// };

  const largestDate = () => {
    const localAuctionDate = new Date(formik?.values?.localAuctionDate);
    const localBuyNowDate = new Date(formik?.values?.localBuyNowDate);
    const exportAuctionDate = new Date(formik?.values?.exportAuctionDate);
    const exportBuyNowDate = new Date(formik?.values?.exportBuyNowDate);

    // Filter out any invalid dates
    const dates = [
        localAuctionDate,
        localBuyNowDate,
        exportAuctionDate,
        exportBuyNowDate
    ].filter(date => !isNaN(date.getTime()));

    // Check if any valid dates exist
    if (dates.length === 0) {
        return null; // or throw an error, or return undefined
    }

    // Find the largest date using Math.max() and the spread operator
    return new Date(Math.max(...dates));
  };

console.log(formik?.values?.localAuctionDate, `localAuctionDate`)

return (
    <Grid container spacing={2} width={"100%"} sx={{ alignItems: "flex-start" }}>
      <Grid item xs={12} lg={isMobile ? 12 : 3}>
        <Typography color="text.form" variant="h6" fontSize={"1rem"}>
          {t("deliveryOption.label")}
        </Typography>
        <Box display={"flex"} gap={2} mt={2}>
          <CustomCheckbox
            label={t("deliveryOption.pickup")}
            selected={formik.values.deliveryOption === CAR_DELIVERY_OPTIONS.Pickup}
            onClick={() => handleDeliveryOptionChange(CAR_DELIVERY_OPTIONS.Pickup)}
          />
          <CustomCheckbox
            label={t("deliveryOption.dropoff")}
            selected={formik.values.deliveryOption === CAR_DELIVERY_OPTIONS.Dropoff}
            onClick={() => handleDeliveryOptionChange(CAR_DELIVERY_OPTIONS.Dropoff)}
          />
        </Box>

        {formik?.values?.deliveryOption === CAR_DELIVERY_OPTIONS.Pickup ? <Typography
          sx={{
            color: "red"
          }}
        >
          GTA pickup service is available for a flat rate of $165
        </Typography> : null}
      </Grid>

      <Grid item xs={12} lg={isMobile ? 12 : 6}
        sx={{
          position: "relative"
        }}
      >
        <Typography color="text.form" variant="h6" fontSize={"1rem"} mb={1}>
          {t("address.carchaser")}: 20-4544 Dufferin St, North York M3H 5X2
        </Typography>
        <AddressAutocomplete setAddress={setAddress}>
          <TextField
            name="address"
            value={formik.values.address}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.address &&
              Boolean(formik.errors.address) &&
              formik.values.deliveryOption === CAR_DELIVERY_OPTIONS.Pickup
            }
            helperText={
              formik.touched.address &&
              formik.errors.address &&
              formik.values.deliveryOption === CAR_DELIVERY_OPTIONS.Pickup
            }
            fullWidth
            placeholder={t("address.placeholder")}
            disabled={formik.values.deliveryOption === CAR_DELIVERY_OPTIONS.Dropoff}
            sx={{
              "& .MuiInputBase-root": { height: 42 },
              "& .MuiOutlinedInput-input": { padding: "10px 14px" },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PinDropOutlined />
                </InputAdornment>
              ),
            }}
          />
        </AddressAutocomplete>
      </Grid>

      <Grid item xs={12} lg={isMobile ? 12 : 3}>
        <Typography color="text.form" variant="h6" fontSize={"1rem"} mb={1}>
          {t("date.label")}
        </Typography>
        <MuiDatePicker
          label={t("date.format")} // e.g., "MM-DD-YYYY"
          disablePast
          minDate={largestDate()}
          value={formik.values.pickupDate}
          onChange={(value) => formik.setFieldValue("pickupDate", value)}
          error={formik.touched.pickupDate && Boolean(formik.errors.pickupDate)}
          helperText={formik.touched.pickupDate && formik.errors.pickupDate}
        />
      </Grid>
    </Grid>
  );
};